import Expander from './view'

export default Expander
